<ng-template #valueTemplate let-item="item">
  <ng-container *ngIf="isUnTypedDetailsItem(item); else typedValue">{{item?.value}}</ng-container>
  <ng-template #typedValue>
    <ng-container [ngSwitch]="item.kind">
      <ng-container *ngSwitchCase="'anchor'">
        <a class="details-link detail-value" *ngIf="item.value" [attr.target]="item.openNewTab?'_blank':null"  [href]="prepareLink(item.href)">{{item.value}}</a>
      </ng-container>
      <ng-container *ngSwitchCase="'hidden'"></ng-container>
      <ng-container class="detail-value" *ngSwitchDefault>{{item.value}}</ng-container>
    </ng-container>
  </ng-template>
</ng-template>

<div *ngIf="data && hasSections(); else renderDetailItems" class="full-height details-items-body">
  <div *ngIf="data['header']" class="main-header">{{ data['header'] }}</div> <!-- main header -->
  <div class="sections-wrapper">
      <div *ngFor="let section of data['sections']" class="section">
        <div class="headerSection">
          <div *ngIf="section.header" class="header">{{section?.header}}</div><!-- section header -->
          <div *ngIf="section.subHeader" class="header">{{section?.subHeader}}</div><!-- section header -->
        </div>
        <div *ngFor="let item of section?.items; let last = last" class="container-fluid">
          <ng-container *ngIf="item.kind == 'hidden'; else itemTemplate"></ng-container>
          <ng-template #itemTemplate>
            <div [ngSwitch]="section.orientation" class="row">
              <div *ngSwitchCase="orientation.Vertical" [ngClass]="{'vertical-layout' : !last}">

                <!-- vertical layout -->
                <div *ngIf="isBlank(item); else verticalItem" class="blank-detail-item"></div>
                <ng-template #verticalItem>
                  <div class="detail-item-white-spaces">{{item?.name}}</div>
                  <div><ng-container *ngTemplateOutlet="valueTemplate; context: { item: item }"></ng-container></div>
                </ng-template>
              </div>

              <div *ngSwitchDefault>
                <div *ngIf="isBlank(item); else horizontalItem" class="blank-detail-item"> </div>
                <!-- horizontal layout -->
                <ng-template #horizontalItem>
                  <div class="detail-item-white-spaces details-flex-item" *ngIf="item.name; else valueOnly">
                    <div class="details-flex-item-name">{{item.name}}</div>
                    <div *ngIf="item.value" class="details-flex-item-value {{cssClass(item)}}"><ng-container *ngTemplateOutlet="valueTemplate; context: { item: item }"></ng-container></div>
                  </div>
                </ng-template>
                <ng-template>
                  <div #valueOnly><ng-container *ngTemplateOutlet="valueTemplate; context: { item: item }"></ng-container></div>
                </ng-template>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
  </div>
</div>

<ng-template #renderDetailItems>
  <div *ngFor="let item of data">
    <h4 *ngIf="item">{{item?.name}} - <ng-container *ngTemplateOutlet="valueTemplate; context: { item: item }"></ng-container></h4>
  </div>
</ng-template>
